import createCartService from '~/service/cart'
import createCheckoutService from '~/service/checkout'
import createShopService from '~/service/shop'
import createPaymentService from '~/service/payment'

export default defineNuxtPlugin({
  name: 'services',
  dependsOn: ['api', 'pinia'],
  async setup() {
    return {
      provide: {
        'cartService': createCartService(),
        'shopService': createShopService(),
        'checkoutService': createCheckoutService(),
        'paymentService': createPaymentService()
      }
    }
  }
})
